<script lang="ts">
    import { createEventDispatcher, onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let options: { value: string; label: string }[] = [];
    export let disabled: boolean = false;
    export let required: boolean = false;
    export let multiple: boolean = false;

    errors[name] = [];

    const dispatch = createEventDispatcher<{ change: string }>();

    const validate = (val: string = value) => {
        errors[name] = [];
        if (required && !val) {
            errors[name].push('Please select an option');
        }
    };
    validate();

    const handleChange = (e: Event) => {
        value = (e.currentTarget as HTMLSelectElement).value;
        validate(value);
        dispatch('change', value);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <select
        {name}
        {disabled}
        {required}
        {multiple}
        value={value}
        on:change={handleChange}
        class:error={errors[name].length > 0}
        on:blur
    >
        {#if !multiple}
            <option value="" disabled hidden>— Choose —</option>
        {/if}
        {#each options as opt}
            <option value={opt.value}>{opt.label}</option>
        {/each}
    </select>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
